import { Button, Col, Form, Input, Row, Spin, Switch } from 'antd';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import React, { useContext, useState } from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import axiosInstance from '../../../../../../../axios_instance';
import {
  IsAdminContext,
  NumberOfExperienceContext,
  UserExperienceDataContext,
} from '../../../../../../../context';
import { errorHandling } from '../../../../../../../utils/helper';
import {
  EndDateValidator,
  StartDateValidator,
  TextLengthValidator,
} from '../../../../../../../utils/validators';
import CheckBoxComponent from '../../../../../check-box';
import styles from './styles.module.scss';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const StyledInput = styled(Input)`
  // color: #d5d5d5 !important;
  ::-webkit-calendar-picker-indicator {
    content: url(/calendar_today.png);
    background: #f6f7fc;
  }
`;

const AddExperience: React.FC<{ setAddNew: any }> = ({
  setAddNew,
}: {
  setAddNew: any;
}) => {
  const [formData, setFormData] = useState<{ [key: string]: number }>({});
  const { userExperienceData, setUserExperienceData } = useContext(
    UserExperienceDataContext
  );
  const [errorMessage, setErrorMessage] = useState<any>({});
  const [allowSubmit, setAllowSubmit] = useState<boolean>(false);
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
  const [isCurrentlyWorking, setIsCurrentlyWorking] = useState<boolean>(false);
  const isAdmin = useContext(IsAdminContext);
  const { employeeId } = useParams();
  const { numberOfExperience, setNumberOfExperience } = useContext(
    NumberOfExperienceContext
  );

  const handleChange = (e: any) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value.trim(),
    });
  };
  const handleChangeText = (value: any, name: string) => {
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleChangeResume = (value: any) => {
    setFormData({
      ...formData,
      ["show_in_resume"]: value,
    });
  };

  const handleCurrentWorkingCheckbox = (e: CheckboxChangeEvent) => {
    setIsCurrentlyWorking(e.target.checked);
  };
  const handleSave = () => {
    setIsSubmitted(true);
    const requestBody: { [key: string]: any } = {};
    requestBody['company_name'] = formData['company_name'];
    // requestBody["job_responsibility"] = ""
    requestBody['designation'] = formData['designation'];
    requestBody['job_responsibility'] = formData['job_responsibility'];
    requestBody['start_date'] = formData['start_date'];
    requestBody['show_in_resume'] = 'show_in_resume' in formData ? formData['show_in_resume'] : true;
    requestBody['end_date'] = isCurrentlyWorking ? null : formData['end_date'];
    let url = '';
    if (isAdmin === '1') {
      url = '/api/v1/admin/profile/experiences';
      requestBody['profile_id'] = employeeId;
    } else {
      url = '/api/v1/profile/experiences';
    }
    axiosInstance
      .post(url, requestBody)
      .then((response) => {
        const orderedExperiences = response.data.order
          .map((experienceId: number) =>
            response.data.experiences.find(
              (experience: any) => experience.experience_id === experienceId
            )
          )
          .filter((item: any) => item !== undefined);
        setUserExperienceData(orderedExperiences);
        setNumberOfExperience(orderedExperiences.length);
        setAddNew(false);
      })
      .catch((error) => {
        errorHandling(error, setErrorMessage);
      })
      .finally(() => {
        setIsSubmitted(false);
      });
  };

  return (
    <div>
      <Form onFinish={handleSave} scrollToFirstError>
        <Row className={styles.row} style={{ paddingBottom: "50px" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px", position: "absolute", bottom: "8px", right: "8px" }}><Switch defaultChecked onChange={handleChangeResume} /><span>Show in resume</span></div>
          <Col span={12}>
            <Row>
              <Form.Item
                name="company_name"
                label=""
                rules={[TextLengthValidator]}
              >
                <p>
                  <span className={styles.title}>Company Name : </span>
                  <Input
                    type="text"
                    placeholder="Write Company Name Here"
                    className={styles.input}
                    name="company_name"
                    onChange={handleChange}
                    style={{
                      borderBottom:
                        'company_name' in errorMessage ? '1px solid red' : '',
                    }}
                  />
                </p>
              </Form.Item>
            </Row>
            <Row>
              <p style={{ color: 'red' }}>
                {'company_name' in errorMessage
                  ? errorMessage['company_name']
                  : ''}
              </p>
            </Row>
            <Row>
              <Form.Item
                name="designation"
                label=""
                rules={[TextLengthValidator]}
              >
                <p>
                  <span className={styles.title}>Designation : </span>
                  <Input
                    type="text"
                    placeholder="Write Designation Here"
                    className={styles.input}
                    name="designation"
                    onChange={handleChange}
                    style={{
                      borderBottom:
                        'designation' in errorMessage ? '1px solid red' : '',
                    }}
                  />
                </p>
              </Form.Item>
            </Row>
            <Row>
              <p style={{ color: 'red' }}>
                {'designation' in errorMessage
                  ? errorMessage['designation']
                  : ''}
              </p>
            </Row>
          </Col>
          <Col span={12}>
            <Row>
              <Form.Item
                name="start_date"
                label=""
                rules={[StartDateValidator]}
              >
                <p>
                  <span className={styles.title}>From : </span>
                  <StyledInput
                    className={styles['input-small']}
                    onChange={handleChange}
                    name="start_date"
                    type="date"
                    style={{
                      borderBottom:
                        'start_date' in errorMessage ? '1px solid red' : '',
                    }}
                  />
                </p>
              </Form.Item>
            </Row>
            <Row>
              <p style={{ color: 'red' }}>
                {'start_date' in errorMessage ? errorMessage['start_date'] : ''}
              </p>
            </Row>
            <Row>
              <Form.Item
                name="end_date"
                label=""
                dependencies={['start_date']}
                rules={[EndDateValidator]}
              >
                <p>
                  <span className={styles.title}>To : </span>
                  <StyledInput
                    disabled={isCurrentlyWorking}
                    className={styles['input-small']}
                    onChange={handleChange}
                    name="end_date"
                    type="date"
                    style={{
                      borderBottom:
                        'end_date' in errorMessage ? '1px solid red' : '',
                    }}
                  />
                </p>
              </Form.Item>
              <Form.Item name="present" label="" dependencies={['start_date']}>
                <CheckBoxComponent
                  text={'Present'}
                  onChange={handleCurrentWorkingCheckbox}
                />
              </Form.Item>
            </Row>
            <Row>
              <p style={{ color: 'red' }}>
                {'end_date' in errorMessage ? errorMessage['end_date'] : ''}
              </p>
            </Row>
          </Col>

          <Col span={24}>
            <div>
              <Form.Item
                name="job_responsibility"
                label=""
                rules={[TextLengthValidator]}
              >
                <p>
                  <span className={styles.title}>Responsibilities : </span>
                  <ReactQuill theme="snow"
                    placeholder="Write roles and responsibilities here"
                    style={{ height: "180px" }}
                    onChange={(val) => handleChangeText(val, "job_responsibility")}
                    className={styles.inputTextArea} />
                </p>
              </Form.Item>
            </div>
            <Row>
              <p style={{ color: 'red' }}>
                {'designation' in errorMessage
                  ? errorMessage['designation']
                  : ''}
              </p>
            </Row>
          </Col>
        </Row>
        <Row>
          {isSubmitted ? <Spin /> : <></>}
          <Form.Item style={{ float: 'right', marginLeft: 'auto' }}>
            <Button
              className={styles['save-button']}
              style={{ float: 'right', marginLeft: 'auto', marginRight: '0px' }}
              type="primary"
              htmlType="submit"
              disabled={
                !formData['company_name'] ||
                !formData['designation'] ||
                !formData['start_date'] ||
                (!formData['end_date'] && !isCurrentlyWorking)
              }
            >
              Save
            </Button>
          </Form.Item>
          <Button
            className={styles['cancel-button']}
            style={{ marginRight: '0px' }}
            onClick={(e) => {
              setAddNew(false);
            }}
          >
            Cancel
          </Button>
        </Row>
      </Form>
    </div>
  );
};

export default AddExperience;
